import React from 'react';

import { Link, Typography } from 'components/alf-design';
import { appStore, googlePlay } from '../../assets/img';

const LandingMarketingAside = () => (
  <div className="flex h-full w-full flex-col pt-[155px] pl-[24px] lg:pl-[128px] pr-[108px]">
    <Typography type="landing" className="text-black">
      Your policy.
    </Typography>
    <Typography type="landing">Your way.</Typography>
    <Typography
      type="landing-paragraph"
      className="mt-[24px] mb-[40px] max-w-[500px]"
    >
      Slide Insurance is committed to providing an exceptional policyholder
      experience that flexes to your needs and preferences. Our new online
      portal, mySlide, puts your policy information and management at your
      fingertips.
    </Typography>
    <div className="flex gap-[32px]">
      <Link
        href="https://play.google.com/store/apps/details?id=com.slideinsurance.myslide.portal"
        target="_blank"
        rel="noopener noreferrer"
        id="googlePlay"
      >
        <img alt="googlePlay" src={googlePlay} />
      </Link>
      <Link
        href="https://apps.apple.com/us/app/slide-insurance/id6593688726"
        target="_blank"
        rel="noopener noreferrer"
        id="appStore"
      >
        <img alt="appStore" src={appStore} />
      </Link>
    </div>
  </div>
);

export default LandingMarketingAside;
